import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-375f270d")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: `action-wrapper ${_ctx.isActive ? '' : 'non-active'} ${
      _ctx.style ? _ctx.style : ''
    }`,
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["stop","prevent"]))
  }, [
    _createVNode("span", null, _toDisplayString(_ctx.text), 1),
    (_ctx.icon)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          src: _ctx.icon
        }, null, 8, ["src"]))
      : _createCommentVNode("", true)
  ], 2))
})